import { NgModule } from "@angular/core";

import { InquiryRoutingModule } from "./inquiry-routing.module";

import { AddinquiryComponent } from "./addinquiry/addinquiry.component";
import { DetailinquiryEditproductComponent } from "./detailinquiry-editproduct/detailinquiry-editproduct.component";
import { DetailinquiryComponent } from "./detailinquiry/detailinquiry.component";
import { EditinquiryComponent } from "./editinquiry/editinquiry.component";
import { InquirydocumentComponent } from "./editinquiry/inquirydocument/inquirydocument.component";
import { InquirylistComponent } from "./inquirylist/inquirylist.component";

import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    InquirydocumentComponent,
    DetailinquiryEditproductComponent,
    InquirylistComponent,
    AddinquiryComponent,
    EditinquiryComponent,
    DetailinquiryComponent,
  ],
  imports: [
    InquiryRoutingModule,
    SharedModule,
  ],
})
export class InquiryModule {}
